import SideBar from '../components/SideBar';
import {ReactComponent as PeopleIcon} from '../components/svgs/peopleIcon.svg';
import StatusDropdown from '../components/StatusDropdown';
import CustomerStatusCard from '../components/CustomerStatusCard';
import CustomerTab from '../components/CustomerTab';
import CustomerHeader from '../components/CustomerHeader';
import { ReactComponent as DashboardIcon } from '../components/svgs/dashboardicon.svg';
import { ReactComponent as OrderIcon } from '../components/svgs/ordersicon.svg';
import { ReactComponent as CustomerIcon } from '../components/svgs/customersicon.svg';



// laundry status data
const laundryStatus = [
  { label: 'Active', link: '#' },
  { label: 'Archived', link: '#' },

];

const AttendantSidebarLinks = [
  { to: '/', icon: <DashboardIcon />, text: 'Dashboard', isActive: false },
  { to: '/orders', icon: <OrderIcon />, text: 'Orders', isActive: false },
  { to: '/customers', icon: <CustomerIcon />, text: 'Customers', isActive: true },

];

const CustomerScreen = () => {
  return (
    <>
        <section className='dashboard-container flex '>
          <aside className=''>
              <SideBar links={AttendantSidebarLinks}/>
          </aside>
          <main className='main-container mb-32'>
              <CustomerHeader orderTitle={'Customers'} orderSubtitle={'Manage customers'} showCreateOrderScreen={true} showCreateCustomerButton={true}/>

            <section className='mt-10 flex gap-5'>
              <CustomerStatusCard icon={<PeopleIcon/>} noOfCustomers={221} noOfOrdersClassName={'custom-style'} dueDay={'In Laundry'} customers={'customers'} customerText={'Customers'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All'} className="ml-20" />}/> 
            </section>
            <section className='mt-20 flex gap-4'>
              <section>
                <CustomerTab/>
              </section>
            </section>
          </main>
        </section>
    </>
    
  )
}

export default CustomerScreen